// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1zKeA","boxTitle":"Qualiphy_boxTitle__OMnn8","box":"Qualiphy_box__3l-W1","toggleWrap":"Qualiphy_toggleWrap__2pBrR"};